import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: Array<any>, filterFunction: any): Array<any> {
    // test value before filter
    return value ? value.filter((e) => filterFunction(e)) : value;
  }

}
